/*
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */

import { MultiBufferStream } from '#/buffer';
import { ISOFile } from '#/isofile';

export function createFile(keepMdatData = false, stream?: MultiBufferStream) {
  /* Boolean indicating if bytes containing media data should be kept in memory */
  const file = new ISOFile(stream, !keepMdatData);
  return file;
}
